import React from "react";
import "./fieldset.scss";
export const Fieldset = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    legend,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("fieldset", {
    className: className,
    ref: ref
  }, /*#__PURE__*/React.createElement("legend", {
    className: "fs-h4 fw-500 mb-3"
  }, legend), children);
});